import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `https://apii.digically.in/api/blogs/`;

const authHeader = () => {
  const token = localStorage.getItem("access");
  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};

/* ================= FETCH BLOGS ================= */
export const fetchBlogs = createAsyncThunk(
  "blogs/fetchBlogs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API_URL, {
        headers: authHeader(), // optional if protected
      });
      return res.data.results; // paginated response
    } catch (error) {
      return rejectWithValue("Failed to fetch blogs");
    }
  }
);

/* ================= CREATE BLOG ================= */
export const createBlog = createAsyncThunk(
  "blogs/createBlog",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, data, {
        headers: { 
          "Content-Type": "multipart/form-data",
          ...authHeader(), 
        },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue("Failed to create blog");
    }
  }
);

/* ================= UPDATE BLOG ================= */
export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}${id}/`, data, {
        headers: { "Content-Type": "multipart/form-data",
          ...authHeader(), },
      });
      return res.data;
    } catch (error) {
      return rejectWithValue("Failed to update blog");
    }
  }
);

/* ================= DELETE BLOG ================= */
export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}${id}/`, {
        headers: authHeader(),
      });
      return id;
    } catch (error) {
      return rejectWithValue("Failed to delete blog");
    }
  }
);

const blogSlice = createSlice({
  name: "blogs",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* Fetch */
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Create */
      .addCase(createBlog.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })

      /* Update */
      .addCase(updateBlog.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (blog) => blog.id === action.payload.id
        );
        if (index !== -1) state.items[index] = action.payload;
      })

      /* Delete */
      .addCase(deleteBlog.fulfilled, (state, action) => {
        state.items = state.items.filter(
          (blog) => blog.id !== action.payload
        );
      });
  },
});

export default blogSlice.reducer;
